import { Component, OnInit, AfterViewInit, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { fadeInOut } from '../../../services/animations';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from "../../../services/app-translation.service";
import { Utilities } from "../../../services/utilities";
import { Configuration, StandardGroupViewModel } from '../../index';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Permission } from '../../../models/permission.model';
import { AuthService } from '../../../services/auth.service';
import { StandardGroupService } from '../../api/api';

@Component({
    selector: 'app-standard-group-list',
    templateUrl: './standard-group-list.component.html',
    styleUrls: ['./standard-group-list.component.scss'],
    animations: [fadeInOut],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StandardGroupListComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort;

  displayedColumns = ['name', 'enabled', 'createdDate', 'updatedDate', 'actions'];
  dataSource: MatTableDataSource<StandardGroupViewModel>;
  loadingIndicator: boolean;

  // Filtering
  currentSearchText: string;

  constructor(private alertService: AlertService,
      private translationService: AppTranslationService,
      private authService: AuthService,
      private standardGroupService: StandardGroupService,
      private snackBar: MatSnackBar,
      private dialog: MatDialog,
      private router: Router,
      private route: ActivatedRoute) {

      this.dataSource = new MatTableDataSource<StandardGroupViewModel>();
      this.currentSearchText = "";

  }

  ngOnInit() {
      this.loadData();
  }

  ngAfterViewInit(): void {
      // Sorting only available in full list mode
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
  }

  public applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue;
  }

  private refresh() {
      // Causes the filter to refresh there by updating with recently added data.
      this.applyFilter(this.dataSource.filter);
  }

  public loadData() {
      this.alertService.startLoadingMessage();
      this.loadingIndicator = true;

      this.standardGroupService.getStandardGroups().subscribe(
          bus => this.onDataLoadSuccessful(bus),
          error => this.onDataLoadFailed(error)
      );
  }

  private onDataLoadSuccessful(aspectGroups: StandardGroupViewModel[]) {
      this.alertService.stopLoadingMessage();
      this.loadingIndicator = false;
      this.dataSource.data = aspectGroups;
  }

  private onDataLoadFailed(error: any) {
      this.alertService.stopLoadingMessage();
      this.loadingIndicator = false;

      this.alertService.showStickyMessage(this.translationService.getTranslation("Error"), this.translationService.getTranslation("FetchErrorMessage") + "\r\n" + Utilities.getHttpResponseMessage(error),
          MessageSeverity.error, error);
  }


  confirmDelete(standardGroup: StandardGroupViewModel) {
      let message: string = this.translationService.getTranslation("commands.Delete") +
          " " +
          standardGroup.name +
          "?";
      let action: string = this.translationService.getTranslation("commands.Delete").toUpperCase();

      this.snackBar.open(message, action, { duration: 5000 })
          .onAction().subscribe(() => {
              this.alertService.startLoadingMessage(
                  this.translationService.getTranslation("globalTexts.DeletingMessage"));
              this.loadingIndicator = true;

              this.standardGroupService.deleteStandardGroup(standardGroup.standardGroupId)
                  .subscribe(results => {
                      this.alertService.stopLoadingMessage();
                      this.loadingIndicator = false;
                      this.alertService.showMessage(this.translationService.getTranslation("commands.Delete"),
                        standardGroup.name + " " + this.translationService.getTranslation("globalTexts.deleted"),
                          MessageSeverity.success);
                      this.loadData();
                  },
                  error => {
                      this.alertService.stopLoadingMessage();
                      this.loadingIndicator = false;

                      let errorMessage = this.translationService.getTranslation("globalTexts.Error") +
                          ": " +
                          Utilities.getHttpResponseMessage(error);

                      this.alertService.showStickyMessage(
                          this.translationService.getTranslation("globalTexts.DeleteError"),
                          errorMessage,
                          MessageSeverity.error,
                          error);
                  });
          });
  }

  hasPermissionToChange(): boolean {
      return this.authService.userHasPermission(Permission.manageModel);
  }

  hasPermissionToDelete(): boolean {
      return this.authService.userHasPermission(Permission.manageModel);
  }

}
